<template>
  <div class="w-full h-auto py-[3.75vw] bg-white">
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          加盟申请
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          携手蓝悦教育 共掘万亿教育市场
        </div>
      </div>
    </div>

    <!-- 表单区域 -->
    <div
      class="w-[61.46vw] h-[12.14vw] mt-[1.93vw] px-[14.83vw] py-[2.60vw] bg-[#05358c] rounded-2xl flex flex-col justify-between mx-auto"
    >
      <Form ref="submitForm" />

      <!-- 提示文本 -->
      <div
        class="w-full h-[2.5vw] min-h-0 flex flex-col justify-end text-white text-[0.63vw] leading-[1.25vw] font-normal font-harmony"
      >
        <p>
          <i class="el-icon-warning"></i>
          请认真、如实、详细填写信息，客服人员会及时与您联系确认。
        </p>
        <p style="text-indent: 1.35em">
          此审批报告仅作初步审核的依据，对您所提供的一切，本公司承诺绝对保密。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "@/components/FormSubmit/Form.vue";
import {EventBus} from "@/utils/bus";
import {handleScrollToForm} from "@/utils/scrollUtils";
export default {
  name: "home-module6",
  components: {
    Form,
  },
    methods: {

    }
};
</script>

<style scoped>
</style>